import ProfileSettingsDialog from "../ProfileButton/ProfileSettingsDialog";

export default ProfileSettingsDialog;